import React, { FC, useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  Button,
  Paper,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import List from './components/errorList';

import Client from 'client-sdk/src/client';

import Icon from '@mdi/react';
import { mdiPaperclip } from '@mdi/js';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';
import { handleErrorList } from '../../utils/helpers';
import AuthContext from '../../authContext';
import {UploadBundlesRequestBuilder} from 'client-sdk/src/bundles/bundle';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    '.margin-date-0': {
      '&.MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    type: {
      flexGrow: 1,
      maxWidth: 500,
    },
    paper: {
      marginTop: '36px',
      width: '100%',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px',
      paddingBottom: '0',
    },

    cardContent: {
      justifyContent: 'space-between',
      paddingLeft: '14px',
    },
    cardContentOrder: {
      paddingBottom: '10px',
    },
    labelInput: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',
      padding: '15px',
      marginTop: '16px',
      borderRadius: '5px',
      border: 'solid 1px #949494',
      borderStyle: 'dashed',
      width: '100%',
      height: '150px',
    },
    uploadInput: {
      cursor: 'pointer',
      alignSelf: 'center',
      position: 'absolute',
      top: '0',
      right: '0',
      width: '100%',
      height: '100%',
      opacity: '0',
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

interface Props {
  history: any;
}

interface Inputs {
  file: null | string;
}

interface Errors {
  code: number;
  text: string;
}

const CreateBundleWithExcel: FC<Props> = ({
  history,
}: Props): React.ReactElement => {
  const token = localStorage.getItem('token') || '';
  const authContext = useContext(AuthContext);
  const { register, handleSubmit, setValue, getValues, watch } =
    useForm<Inputs>({
      defaultValues: {
        file: null,
      },
    });
  const classes = useStyles();
  const [file, setFile] = useState<any>('');
  const [loading, setLoading] = useState(false as boolean);
  const [errorList, setErrorList] = useState<null | Errors[]>(null);

  const onSubmit = async ({ file }: Inputs) => {
    try {
      setLoading(true);
      let payload = new FormData();
      payload.append('file', file[0]);
      const makeRequest = new UploadBundlesRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication('سفارشات با موفقیت ایجاد شدند', 'success');
      history.push('/orders');
    } catch (err) {
      console.log(err.response)
      if (err.response?.status === 400) {
        // handleNotfication(err.response?.data?.title, 'error');
        setErrorList([{code: "", text: err.response?.data?.title}]);
      }
      if (err?.response.status === 406) {
        // @ts-ignore
        handleNotfication(
          'فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید',
          'error'
        );
        // @ts-ignore
        setErrorList(handleErrorList(err.response.data));
      }
      if (
        err.response?.status == 406 &&
        err.response.data.errorKey == 'OrderItem.SkuId.not_acceptable'
      ) {
        err.response.data.errorList.forEach(el => {
          handleNotfication(
            `کالا با کد ${el.productCode} و کدتنوع ${el.variantCode} موجود نیست`,
            'error'
          );
        });
      }
      handleError(err.response);
    } finally {
      setFile(null);
      setValue('file', null);
      setLoading(false);
    }
  };

  // const handleUploadBundles = async () => {
  //   try {
  //     setLoading(true);
  //     let payload = new FormData();
  //     payload.append('file', file);
  //     const makeRequest = new UploadBundlesRequestBuilder()
  //       .data(payload)
  //       .build();
  //     const client = new Client(token);
  //     await client.execute(makeRequest);
  //     handleNotfication('مرسوله ها با موفقیت ایجاد شدند', 'success');
  //   }
  //   catch (err) {
  //     if (err?.response.status === 406) {
  //       handleNotfication('فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید', 'error')
  //       return;
  //     }
  //     handleError(err.response);
  //   }
  //   finally {
  //     setLoading(false)
  //     handleCloseConfirmModal();
  //     handleCloseExelModal();
  //   }
  // };

  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };

  return (
  <React.Fragment>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              ایجاد مرسوله با اکسل
            </Typography>
          </div>
        </Paper>
      </Grid>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid md={12} lg={12} item>
          <Card
            className={classes.card}
            style={{ marginTop: '0', paddingBottom: '24px' }}
          >
            <CardHeader
              avatar={
                <Grid>
                  <Typography className={classes.typographyCards}>
                    بارگذاری فایل
                  </Typography>
                </Grid>
              }
            />

            <CardContent className={classes.cardContentOrder}>
              <Grid container lg={12} md={12} className={classes.cardContent}>
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    padding: '0',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <Grid container sm={5} md={5}>
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      style={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        justifyContent: 'right',
                        textAlign: 'right',
                        marginBottom: '-10px',
                      }}
                    >
                      <Link
                          to="/creatboundle.xlsx"
                          style={{
                            color: '#DFA01F',
                            borderBottom: 'solid 1px #DFA01F',
                            paddingBottom: '3px',
                            textDecoration: 'none',
                          }}
                          target="_blank"
                        >
                          {'دریافت فایل نمونه'}
                        </Link>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                      }}
                    >
                      <div style={{ display: 'flex', width: '100%' }}>
                        <div className={classes.item}>
                          {/* <TextField
                            id="amount"
                            name="amount"
                            variant="outlined"
                            className={classes.textInput}
                            style={{padding: '10px 5px', marginTop: '16px'}}
                            value={file ? file?.name : null}
                            placeholder="بارگذاری فایل"
                            disabled
                          /> */}
                          <br />
                          <label htmlFor="file" className={classes.labelInput}>
                            <Icon
                              color={'#666666'}
                              path={mdiPaperclip}
                              size={2}
                            />
                            <Typography>
                              {file ? file?.name : 'فایل خود را اینجا رها کنید'}
                            </Typography>
                            <Typography
                              style={{
                                color: '#0375E8',
                                borderBottom: 'solid 1px #0375E8',
                              }}
                            >
                              انتخاب فایل از کامپیوتر
                            </Typography>

                            <input
                              id="file"
                              type="file"
                              name="file"
                              onChange={handleChangeFileInput}
                              ref={register({ required: true })}
                              multiple
                              className={classes.uploadInput}
                            />
                          </label>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        {errorList && (
          <Grid md={12} lg={12} item>
            <Card
              className={classes.card}
              style={{ padding: '15px 0', marginTop: '0' }}
            >
              <CardHeader
                avatar={
                  <Grid>
                    <Typography className={classes.typographyCards}>
                      لیست خطاها
                    </Typography>
                  </Grid>
                }
              />

              <CardContent className={classes.cardContentOrder}>
                <Grid container lg={12} md={12} className={classes.cardContent}>
                  <Grid container item xs={12} alignItems="flex-end">
                    <div className={classes.item}>
                      <>
                        <List data={errorList} />
                      </>
                    </div>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
        <Grid
          container
          lg={12}
          md={12}
          xs={12}
          spacing={2}
          style={{
            flexDirection: 'row-reverse',
            position: 'fixed',
            backgroundColor: '#D5DADD',
            bottom: '0',
            right: '75px',
            padding: '15px',
            zIndex: 2,
          }}
        >
          <Grid
            container
            style={{
              marginLeft: '35px',
              marginTop: '-4px',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="medium"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
                padding: '2px 30px',
              }}
              data-cy="cancelBtn"
            >
              {'انصراف'}
            </Button>
            <Button
              style={{
                marginRight: '14px',
                marginLeft: '90px',
              }}
              type="submit"
              disabled={loading}
              size="medium"
              data-cy="saveBtn"
              autoFocus
              variant="contained"
              color="primary"
            >
              ذخیره مرسوله
            </Button>
          </Grid>
        </Grid>
      </form>
      {/* <form onSubmit={handleSubmit(onSubmit)} style={{width: '100%'}}>
        <Grid container style={{margin: '10px 0'}} alignItems="flex-start">
          <Grid container item xs={12} alignItems="flex-start">
            <Grid item container justify="flex-end" xs={12}>
              <Button
                type="submit"
                disabled={loading}
                size="large"
                data-cy="search"
                autoFocus
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPlus} size={1} />}
              >
                ثبت سفارش
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form> */}
    </React.Fragment>
  )
};

export default CreateBundleWithExcel;
